import * as Dialog from "@radix-ui/react-dialog";
import { Button } from "@/components";
import { Close } from "@/icons";
import "./DocumentUploadModalHeader.scss";
import { PropsWithChildren, ReactNode } from "react";

type DocumentUploadModalHeaderProps = PropsWithChildren<{
  closeButton?: string;
  onCloseClick?: () => void;
  children?: ReactNode;
}>;

export const DocumentUploadModalHeader = ({
  closeButton = "Chiudi",
  onCloseClick,
  children,
}: DocumentUploadModalHeaderProps) => {
  return (
    <header className="ui-upload-modal-header bg-white">
      <Dialog.Title className="fs-6 md-fs-custom text-slate-20 fw-bold">
        {children}
      </Dialog.Title>
      <Dialog.Close asChild className="ui-upload-modal-header-close">
        <Button
          size="4"
          variant={"closeModal"}
          aria-label="Chiudi modale"
          onClick={onCloseClick}
        >
          {closeButton}
          <Close className="ml-x8" width={32} height={32} />
        </Button>
      </Dialog.Close>
    </header>
  );
};
